
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("lTc1q", function(module, exports) {
module.exports = JSON.parse("{}");

});


//# sourceMappingURL=de.7bc39338.js.map
